/**
 * `True` if running React in a development environment
 */
export const isDev: boolean =
  process.env.REACT_APP_HOSTING_ENVIRONMENT === "development";
